
import {Col, DropdownButton, Dropdown, ProgressBar, Row, Table} from "react-bootstrap";
import EmptyListImage from "../../resources/images/empty-list.svg";
import PerfectScrollbar from 'react-perfect-scrollbar'
import Icon from "../icon";

const Entities = (props) => {
    const {columns, selectAll, checked, handleCheck, isLoading, entities, progress, rowActions, idColumn} = props
    const isChecked = (item) => checked.includes(item);
    const coreRows = rowActions?.length > 0 ? 4 : 3;

    const handleRowAction = (action, entity) => {
        if(typeof action?.onClick == "function"){
            action.onClick(entity);
        }
    }

    return (
        <Row>
            <Col>
                {progress > 0 && progress < 100 && <ProgressBar animated className="mt-2" now={progress} label={`${progress}%`} />}
                <div className="table-data">
                    <PerfectScrollbar className={rowActions ? "has-actions" : ""}>
                        <Table>
                            <thead>
                            <tr>
                                <th width={5}></th>
                                <th className="intro">
                                    <input type="checkbox" name="select_all" onClick={selectAll}/>
                                </th>
                                {columns && columns.map((column) => {
                                    return <th className={`th-size-${column?.size ? column.size : 'auto'}`} key={column.prop}>{column.label}</th>
                                })}
                                <th className="intro" width={5}></th>
                            </tr>
                            </thead>
                            <tbody>

                            {isLoading && Array.from(Array(10).keys()).map((index) => {
                                return <tr key={`placeholder_${index}`}>
                                    <td className="loading-td" colSpan={(columns.length + coreRows)}>&nbsp;</td>
                                </tr>
                            })}

                            {!isLoading && entities?.length > 0 && entities.map((entity, index) => {
                                return <tr key={`tr_entity_${index}`}>
                                    <td width={5}></td>
                                    <td className="intro">
                                        <input type="checkbox" checked={isChecked(idColumn ? entity[idColumn] : entity?._id?.$oid)} value={idColumn ? entity[idColumn] : entity?._id?.$oid} onChange={handleCheck}/>
                                    </td>
                                    {columns && columns.map((column) => {
                                        return <td key={`column_${column.label}`}>
                                            {typeof column.output === "function" ? column.output(entity) : entity[column.prop]}
                                        </td>
                                    })}
                                    {rowActions && <td key="row_actions" className="row-actions" width={5}>
                                        <DropdownButton size="sm" variant="white" id="dropdown-basic-button" title={<Icon name="menu" />}>
                                            {rowActions.map((action, index) => {
                                                const path = action?.path ? action?.path.replace(':id', idColumn ? entity[idColumn] : entity?._id?.$oid) : "#";
                                                return <Dropdown.Item onClick={ev => handleRowAction(action, entity)} key={`row_actions_${index}`} href={path}>
                                                    {action?.icon && <Icon name={action.icon} className="me-2" />}
                                                    {action?.label}
                                                </Dropdown.Item>
                                            })}
                                        </DropdownButton>
                                    </td> }
                                    <td className="intro" width={5}></td>
                                </tr>
                            })}
                            {!isLoading && entities?.length === 0 && <tr>
                                <td colSpan={columns?.length + coreRows}>
                                    <div className="empty-list">
                                        <div className="text-center">
                                            <img alt="empty-list" src={EmptyListImage}/>
                                            <h6>No data found</h6>
                                        </div>
                                    </div>
                                </td>
                            </tr>}
                            </tbody>
                        </Table>
                    </PerfectScrollbar>
                </div>
            </Col>
        </Row>
    )
}

export default Entities